import { RouteIds } from '../types';
import { combineLatest, Observable } from 'rxjs';
import { GoogleAnalyticsParametersType } from './google-analytics-parameters.type';
import { inject, Injectable } from '@angular/core';
import { QuoteDataLayerStrategy } from './quote-data-layer.strategy';
import { QuoteDataLayerService } from './quote-data-layer.service';
import { QuoteToolLiteStore } from '../store';
import { map } from 'rxjs/operators';
import { Flows, Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class OnlineQuoteDataLayerStrategy implements QuoteDataLayerStrategy {
  readonly flow: Flow = Flows.Online;
  quoteFieldsBuilders = undefined;

  private readonly quoteDataLayerService = inject(QuoteDataLayerService);
  private readonly quoteToolLiteStore = inject(QuoteToolLiteStore);

  initializeDataLayerStepsBuilders(): void {
    this.quoteFieldsBuilders = {
      [RouteIds.course]: this.getQuoteBaseDataBuilder(),
      [RouteIds.extras]: this.getQuoteBaseDataBuilder(),
      [RouteIds.applicant]: this.getQuoteBaseDataBuilder(),
      [RouteIds.quote]: this.getAllQuoteRelatedDataBuilder(),
      [RouteIds.booking]: this.getAllQuoteRelatedDataBuilder(),
      [RouteIds.confirmation]: this.getAllQuoteRelatedDataBuilder(),
      [RouteIds.payment]: this.getAllQuoteRelatedDataBuilder(),
    };
  }

  buildDataLayer(): Observable<Partial<GoogleAnalyticsParametersType>> {
    return this.quoteDataLayerService.buildQuoteDataLayerObject(this.quoteFieldsBuilders);
  }

  private getQuoteBaseDataBuilder() {
    return () => this.getQuoteBaseData();
  }

  private getQuoteBaseData() {
    return combineLatest([this.quoteDataLayerService.getBaseData(), this.quoteToolLiteStore.selectionForOnlineFlowDataLayer$]).pipe(
      map(([baseData, { selectedClassTimeLabel, selectedTimezoneName }]) => ({
        ...baseData,
        quote_class_time: selectedClassTimeLabel,
        quote_time_zone: selectedTimezoneName,
      })),
    );
  }

  private getAllQuoteRelatedDataBuilder() {
    return () =>
      combineLatest([this.getQuoteBaseData(), this.quoteDataLayerService.getPricesData()]).pipe(
        map(([baseData, prices]) => ({
          ...baseData,
          ...prices,
        })),
      );
  }
}
